import React from 'react';
import { ArrowRight as ArrowRightIcon, ArrowUUpLeft as LoopIcon } from '@phosphor-icons/react';
import { Section, SectionTitle, Lead } from '../Section';
import { modelSteps } from '../../data/proposal';
export function ModelSection() {
  return <Section id="model" index="10" label="Campaign model" fill data-id="element-145" data-mp="nwg868zbhzj3">
      <div className="grid gap-5 lg:grid-cols-[1fr_0.85fr] lg:items-end lg:gap-14" data-id="element-146" data-mp="sxvsfyto820f">
        <SectionTitle data-id="element-147" data-mp="wyz5kdkc3jxy">A closed loop, not a campaign burst.</SectionTitle>
        <Lead data-id="element-148" data-mp="11xiwythp5nxp">
          The economics work because the creative concept isn’t reinvented for every clinician —
          only the case is. And every wave is briefed by the last one.
        </Lead>
      </div>

      <div className="mt-6 flex min-h-0 flex-1 flex-col" data-id="element-149" data-mp="1bn2h02h5bnu5">
        <ol className="grid min-h-0 flex-1 gap-3 sm:grid-cols-2 lg:flex lg:items-stretch lg:gap-2" data-id="element-150" data-mp="1bmka8bwuxr7z">
          {modelSteps.map((step, i) => <React.Fragment key={step.title} data-id="element-151" data-mp="1knqrin7bz62a" data-mpi={i}>
              <li className="relative flex flex-1 flex-col rounded-xl border border-white/10 bg-white/[0.03] p-5" data-id="element-152" data-mp="1kojqh201sr9v">
                <span className="flex h-10 w-10 items-center justify-center rounded-full border border-primary/50 font-body text-xs tracking-[0.12em] text-primary" data-id="element-153" data-mp="lfd6v4zecqvk">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <h3 className="mt-4 font-heading text-xl uppercase tracking-wide text-white" data-id="element-154" data-mp="6kp5o3114elr">
                  {step.title}
                </h3>
                <p className="mt-2 font-body text-sm leading-relaxed text-white/60" data-id="element-155" data-mp="14761f3u46k5e">{step.body}</p>
              </li>
              {i < modelSteps.length - 1 ? <li aria-hidden="true" className="hidden shrink-0 items-center lg:flex" data-id="element-156" data-mp="uhcp20m5e103">
                  <ArrowRightIcon size={20} className="text-primary" data-id="element-157" data-mp="pjl09fgsuv04" />
                </li> : null}
            </React.Fragment>)}
        </ol>

        <div className="relative mt-4 rounded-xl border border-dashed border-primary/40 bg-primary/[0.05] px-5 py-3.5" data-id="element-158" data-mp="1n09zd1ed7j5t">
          <div className="flex flex-wrap items-center gap-3" data-id="element-159" data-mp="3cft1uxwqvjac">
            <LoopIcon size={20} weight="bold" className="text-primary" aria-hidden="true" data-id="element-160" data-mp="3cgcga4n6rpjm" />
            <p className="font-heading text-base text-white lg:text-lg" data-id="element-161" data-mp="3hdui7b2sd4i4">
              Insight from step 04 rebriefs step 02 — the strongest clinicians, hooks and channels
              shape the next wave of cases.
            </p>
            <span className="ml-auto rounded-full border border-primary/50 bg-background/60 px-3 py-1 font-body text-[11px] uppercase tracking-[0.16em] text-primary" data-id="element-162" data-mp="2tp2yz976bwhh">
              The loop closes
            </span>
          </div>
        </div>
      </div>
    </Section>;
}